import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetRepairs({ plants, zones, startAt, endAt }) {
  const params = new URLSearchParams({
    start_at: startAt,
    end_at: endAt,
    zones: zones.join(),
    plants: plants.join(),
  })

  return api.get(`/repairs?${params.toString()}`).then((resp) => resp.data)
}
